module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p6"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p7"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedman0007#rpt01"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIRST")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STEPS")])]), _vm._v(" "), _c('h1', {
    staticClass: "ps"
  }, [_vm._v("Making a Life as a Writer")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p7"
    }
  }), _vm._v("In the history of professional writing and authorship, there have been several revolutions in how writers get published and get paid: the invention of the printing press (mid-1400s), the legislation of copyright (early 1700s), the growth of literacy (1800s), and the expansion of the internet and digital publishing (2000s).")]), _vm._v(" "), _c('p', [_vm._v("Some believe the digital era is making it increasingly difficult for authors to earn a decent living from their writing. I don’t agree: it has always been difficult. Every revolution, including the one we’re living through now, stirs up excitement, but also confusion and fear of change. In the late 1800s, during what some now consider a golden age for publishing (for magazines especially), you could find disgruntled writers. One complained to a US congressional committee that he did not know any author who made a living by writing literary work. Of all the learned professions, he said, “Literature is the most poorly paid.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chifriedman0050#en1",
      "id": "en1r"
    }
  }, [_vm._v("1")])]), _vm._v(" The truth is that many writers’ careers, during every era, have been gifted into existence by birth, by privilege, by marriage.")]), _vm._v(" "), _c('p', [_vm._v("Throughout history, authors have laid the blame for their less than desirable economic situation on publishers, but such accusations almost always betray ignorance of how publishing works. In the digital era, it is also common to blame authors’ suffering on Silicon Valley giants, such as Google. Neither industry deserves most of the blame we heap upon it. During each revolution, authors (and publishers as well) typically seek to preserve the existing system, even if new methods of publishing and distribution have rendered it unworkable. Today, authors’ organizations express overarching pessimism: author earnings are lower than ever, they dubiously claim. But this is no reason to be dissuaded from a writing career if that’s what you want. It remains possible to make a decent living from writing if you’re willing to pay attention to how the business works, devise a business model tailored to your goals, and adapt as needed.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p8"
    }
  }), _vm._v("Many serious writers take for granted that art and business are antithetical to one another. Before a word is published—before they’ve encountered any aspect of the business of their art—they assume that they are bad at business or that attending to business concerns will pollute their creative efforts. Too few are open to the possibility that the business side calls for as much imagination as the artistic process itself. Industry expert Richard Nash once tweeted, “Business & marketing are about understanding networks and patterns of influence and behavior. Writers can handle that.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chifriedman0050#en2",
      "id": "en2r"
    }
  }, [_vm._v("2")])]), _vm._v(" To be sure, business can and does ask for compromises, but that’s not always to the detriment of art. A bit of friction, some kind of barrier—a net on the tennis court!—is healthy.")]), _vm._v(" "), _c('p', [_vm._v("In the literary community, there’s a persistent and dangerous myth of the starving artist, a presumption that “real art” doesn’t earn money. In fact, art and business can each inform the other, and successful writers throughout history have proven themselves savvy at making their art pay. Dana Gioia, both a celebrated poet and former vice president at General Foods, said, “There is a natural connectivity, at least in American culture, between the creative and the commercial.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chifriedman0050#en3",
      "id": "en3r"
    }
  }, [_vm._v("3")])]), _vm._v(" An open attitude toward business can provide focus, discipline, and, sometimes most importantly, self-awareness about what you want and expect from your writing career.")]), _vm._v(" "), _c('p', [_vm._v("The following chapters will help you take the first steps toward a writing life based on your own strengths, rather than some unattainable ideal. To that end, they focus on the big picture of building your career. Details about specific types of writing and publishing will follow in later parts of the book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bdfd030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-friedman-0009.vue
// module id = 78
// module chunks = 0